import { ErrorSubCategory } from '../constants/errorSubCategory';
export const getErrorSubCategoryFromError = error => {
  if (error.responseJSON && error.responseJSON.subCategory) return error.responseJSON.subCategory.replace('ProductApprovalsApiErrorSubCategory.', '');
  return ErrorSubCategory.UNKNOWN_ERROR;
};